import { AnalyticCategories, AnalyticService } from '@application/analytic/analytic.service';
import { AnalyticProvider } from '@application/analytic/analytic_context.provider';
import { withTranslation } from '@application/i18n/with_translation';
import { useTitle } from '@application/use_title';
import { Flex } from '@cellula/react';
import { TopBar } from '@component/top_bar.component';
import { useResolve } from '@visiba/instantiation';
import { useCreateNewMessage } from '../hooks/use-create-new-message';
import { ScreenError } from '../screens/error';
import { CreateNewMessageRoutes } from './create-new-message-routes';
import { Skeleton } from './skeleton';

export const CreateNewMessageLayout = () => {
	const { deleteBasket, goToReceptionHome, flowData } = useCreateNewMessage();
	const analyticService = useResolve(AnalyticService);
	const isLoading = flowData.flowState === 'pending';
	const isError = flowData.flowState === 'error';

	useTitle(withTranslation('View.CreateNewMessage.Title'));

	const handleAbort = async () => {
		analyticService.trackEvent(AnalyticCategories.CreateNewMessage, 'Clicked', 'Abort button');

		deleteBasket().finally(() => {
			goToReceptionHome();
		});
	};

	return (
		<AnalyticProvider category={AnalyticCategories.CreateNewMessage}>
			<Flex grow='1'>
				<TopBar.Content title={withTranslation('View.CreateNewMessage.Title')} onAbort={handleAbort} />
				{isLoading && <Skeleton />}
				{isError && <ScreenError />}
				{!isLoading && !isError && <CreateNewMessageRoutes />}
			</Flex>
		</AnalyticProvider>
	);
};
